import { ModelMixin } from '@models/core/base-generic.model';
import { Moment } from 'moment';

export class XeroIntegrationJobRun extends ModelMixin<XeroIntegrationJobRun>() {
    protected static _resource = 'payroll/companies/:company/xero/integrationJobRuns';

    protected static _type = 'xeroXeroIntegrationJobRuns';

    protected static _serializeAttributes = ['status', 'statusMessage', 'createdAt'];

    protected static _dates = ['createdAt'];

    private _isInvalidJson = false;
    private _jsonMessages?: string[];

    get status(): string {
        return this._attributes['status'];
    }

    set status(val: string) {
        this._attributes['status'] = val;
    }

    get statusMessage(): string {
        return this._attributes['statusMessage'];
    }

    set statusMessage(val: string) {
        this._attributes['statusMessage'] = val;
    }

    get createdAt(): Moment {
        return this._attributes['createdAt'];
    }

    set createdAt(val: Moment) {
        this._attributes['createdAt'] = val;
    }

    /**
     * Messages parsed from the JSON payload
     */
    get jsonMessages(): string[] | false {
        if (this._isInvalidJson) {
            return false;
        }

        if (!this._jsonMessages) {
            try {
                this._jsonMessages = this.parseJsonMessages();
            } catch {
                this._isInvalidJson = true;

                return false;
            }
        }

        return this._jsonMessages;
    }

    private parseJsonMessages(): string[] {
        const messages: string[] = [];

        JSON.parse(this.statusMessage, (key, value) => {
            if (key === 'Message' && typeof value === 'string') {
                messages.push(value);
            }

            return value;
        });

        return messages;
    }
}
